import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';
const VISIBLE_DURATION = 6000;
const REAPPEAR_DELAY = 10000;
export function RecentPurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const lastIndex = useRef(0);
  const prefersReducedMotion = useReducedMotion();
  const chooseNextPurchase = useCallback(() => {
    if (recentPurchases.length < 2) return;
    let nextIndex = Math.floor(Math.random() * recentPurchases.length);
    while (nextIndex === lastIndex.current) {
      nextIndex = Math.floor(Math.random() * recentPurchases.length);
    }
    lastIndex.current = nextIndex;
    setIndex(nextIndex);
  }, []);
  useEffect(() => {
    if (recentPurchases.length === 0) return;
    let showTimer: ReturnType<typeof setTimeout>;
    let hideTimer: ReturnType<typeof setTimeout>;
    const showPurchase = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        showTimer = setTimeout(() => {
          chooseNextPurchase();
          showPurchase();
        }, REAPPEAR_DELAY);
      }, VISIBLE_DURATION);
    };
    showTimer = setTimeout(showPurchase, 1000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [chooseNextPurchase]);
  if (recentPurchases.length === 0) return null;
  const purchase = recentPurchases[index];
  const transition = prefersReducedMotion ? {
    duration: 0.15
  } : {
    duration: 0.45,
    ease: [0.22, 1, 0.36, 1]
  };
  return <AnimatePresence data-id="element-181" data-mp="2478smvr7ve5c">
      {visible && <motion.aside key={purchase.nombre} role="status" aria-live="polite" initial={prefersReducedMotion ? {
      opacity: 0
    } : {
      opacity: 0,
      x: '120%'
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={prefersReducedMotion ? {
      opacity: 0
    } : {
      opacity: 0,
      x: '120%'
    }} transition={transition} className="fixed bottom-5 right-5 z-40 w-[calc(100%-2.5rem)] max-w-[340px] rounded-2xl border border-emerald-400/35 bg-black px-5 py-4 pr-11 text-left text-white shadow-2xl shadow-black/40" data-id="element-182" data-mp="1za8wbck65prf">
          <button type="button" aria-label="Cerrar notificación de compra" onClick={() => setVisible(false)} className="absolute right-3 top-3 inline-flex h-7 w-7 items-center justify-center rounded-full text-zinc-400 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400" data-id="element-183" data-mp="3rp71vszvitkw">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-184" data-mp="3dra814ct119x" />
          </button>

          <p className="flex items-center gap-2 text-xs font-extrabold tracking-wide text-emerald-400" data-id="element-185" data-mp="3dtd86h7o8asd">
            <span className="h-2 w-2 rounded-full bg-emerald-400" aria-hidden="true" data-id="element-186" data-mp="2ga214ujaz53x" />
            COMPRA VERIFICADA
          </p>
          <p className="mt-3 font-display text-base font-bold text-white" data-id="element-187" data-mp="12gd42rmt5btw">{purchase.nombre}</p>
          <p className="mt-1 text-sm leading-snug text-zinc-200" data-id="element-188" data-mp="yej82wnk4w02">
            compró <span className="font-bold text-emerald-400" data-id="element-189" data-mp="ycf5ci1ea31d">{purchase.producto}</span> 🏆
          </p>
          <p className="mt-2 text-xs text-zinc-500" data-id="element-190" data-mp="tgzs9sb7ob60">{purchase.tiempo}</p>
        </motion.aside>}
    </AnimatePresence>;
}